var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

/*!
 * 
 * litepicker.umd.js
 * Litepicker v2.0.11 (https://github.com/wakirin/Litepicker)
 * Package: litepicker (https://www.npmjs.com/package/litepicker)
 * License: MIT (https://github.com/wakirin/Litepicker/blob/master/LICENCE.md)
 * Copyright 2019-2021 Rinat G.
 *     
 * Hash: 8991663e2f73caec8a52
 * 
 */
!function (t, e) {
  exports = e();
}(window, function () {
  return function (t) {
    var e = {};

    function i(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, n) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) i.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
      return n;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 4);
  }([function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t(e, i, n) {
        void 0 === e && (e = null), void 0 === i && (i = null), void 0 === n && (n = "en-US"), (this || _global).dateInstance = "object" == typeof i && null !== i ? i.parse(e instanceof t ? e.clone().toJSDate() : e) : "string" == typeof i ? t.parseDateTime(e, i, n) : e ? t.parseDateTime(e) : t.parseDateTime(new Date()), (this || _global).lang = n;
      }

      return t.parseDateTime = function (e, i, n) {
        if (void 0 === i && (i = "YYYY-MM-DD"), void 0 === n && (n = "en-US"), !e) return new Date(NaN);
        if (e instanceof Date) return new Date(e);
        if (e instanceof t) return e.clone().toJSDate();
        if (/^-?\d{10,}$/.test(e)) return t.getDateZeroTime(new Date(Number(e)));

        if ("string" == typeof e) {
          for (var o = [], s = null; null != (s = t.regex.exec(i));) "\\" !== s[1] && o.push(s);

          if (o.length) {
            var r = {
              year: null,
              month: null,
              shortMonth: null,
              longMonth: null,
              day: null,
              value: ""
            };
            o[0].index > 0 && (r.value += ".*?");

            for (var a = 0, l = Object.entries(o); a < l.length; a++) {
              var c = l[a],
                  h = c[0],
                  p = c[1],
                  d = Number(h),
                  u = t.formatPatterns(p[0], n),
                  m = u.group,
                  f = u.pattern;
              r[m] = d + 1, r.value += f, r.value += ".*?";
            }

            var g = new RegExp("^" + r.value + "$");

            if (g.test(e)) {
              var v = g.exec(e),
                  y = Number(v[r.year]),
                  b = null;
              r.month ? b = Number(v[r.month]) - 1 : r.shortMonth ? b = t.shortMonths(n).indexOf(v[r.shortMonth]) : r.longMonth && (b = t.longMonths(n).indexOf(v[r.longMonth]));
              var k = Number(v[r.day]) || 1;
              return new Date(y, b, k, 0, 0, 0, 0);
            }
          }
        }

        return t.getDateZeroTime(new Date(e));
      }, t.convertArray = function (e, i) {
        return e.map(function (e) {
          return e instanceof Array ? e.map(function (e) {
            return new t(e, i);
          }) : new t(e, i);
        });
      }, t.getDateZeroTime = function (t) {
        return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
      }, t.shortMonths = function (e) {
        return t.MONTH_JS.map(function (t) {
          return new Date(2019, t).toLocaleString(e, {
            month: "short"
          });
        });
      }, t.longMonths = function (e) {
        return t.MONTH_JS.map(function (t) {
          return new Date(2019, t).toLocaleString(e, {
            month: "long"
          });
        });
      }, t.formatPatterns = function (e, i) {
        switch (e) {
          case "YY":
          case "YYYY":
            return {
              group: "year",
              pattern: "(\\d{" + e.length + "})"
            };

          case "M":
            return {
              group: "month",
              pattern: "(\\d{1,2})"
            };

          case "MM":
            return {
              group: "month",
              pattern: "(\\d{2})"
            };

          case "MMM":
            return {
              group: "shortMonth",
              pattern: "(" + t.shortMonths(i).join("|") + ")"
            };

          case "MMMM":
            return {
              group: "longMonth",
              pattern: "(" + t.longMonths(i).join("|") + ")"
            };

          case "D":
            return {
              group: "day",
              pattern: "(\\d{1,2})"
            };

          case "DD":
            return {
              group: "day",
              pattern: "(\\d{2})"
            };
        }
      }, t.prototype.toJSDate = function () {
        return (this || _global).dateInstance;
      }, t.prototype.toLocaleString = function (t, e) {
        return (this || _global).dateInstance.toLocaleString(t, e);
      }, t.prototype.toDateString = function () {
        return (this || _global).dateInstance.toDateString();
      }, t.prototype.getSeconds = function () {
        return (this || _global).dateInstance.getSeconds();
      }, t.prototype.getDay = function () {
        return (this || _global).dateInstance.getDay();
      }, t.prototype.getTime = function () {
        return (this || _global).dateInstance.getTime();
      }, t.prototype.getDate = function () {
        return (this || _global).dateInstance.getDate();
      }, t.prototype.getMonth = function () {
        return (this || _global).dateInstance.getMonth();
      }, t.prototype.getFullYear = function () {
        return (this || _global).dateInstance.getFullYear();
      }, t.prototype.setMonth = function (t) {
        return (this || _global).dateInstance.setMonth(t);
      }, t.prototype.setHours = function (t, e, i, n) {
        void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), (this || _global).dateInstance.setHours(t, e, i, n);
      }, t.prototype.setSeconds = function (t) {
        return (this || _global).dateInstance.setSeconds(t);
      }, t.prototype.setDate = function (t) {
        return (this || _global).dateInstance.setDate(t);
      }, t.prototype.setFullYear = function (t) {
        return (this || _global).dateInstance.setFullYear(t);
      }, t.prototype.getWeek = function (t) {
        var e = new Date(this.timestamp()),
            i = (this.getDay() + (7 - t)) % 7;
        e.setDate(e.getDate() - i);
        var n = e.getTime();
        return e.setMonth(0, 1), e.getDay() !== t && e.setMonth(0, 1 + (4 - e.getDay() + 7) % 7), 1 + Math.ceil((n - e.getTime()) / 604800000);
      }, t.prototype.clone = function () {
        return new t(this.toJSDate());
      }, t.prototype.isBetween = function (t, e, i) {
        switch (void 0 === i && (i = "()"), i) {
          default:
          case "()":
            return this.timestamp() > t.getTime() && this.timestamp() < e.getTime();

          case "[)":
            return this.timestamp() >= t.getTime() && this.timestamp() < e.getTime();

          case "(]":
            return this.timestamp() > t.getTime() && this.timestamp() <= e.getTime();

          case "[]":
            return this.timestamp() >= t.getTime() && this.timestamp() <= e.getTime();
        }
      }, t.prototype.isBefore = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            return t.getTime() > this.getTime();

          case "day":
          case "days":
            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

          case "month":
          case "months":
            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();

          case "year":
          case "years":
            return t.getFullYear() > this.getFullYear();
        }

        throw new Error("isBefore: Invalid unit!");
      }, t.prototype.isSameOrBefore = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            return t.getTime() >= this.getTime();

          case "day":
          case "days":
            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

          case "month":
          case "months":
            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
        }

        throw new Error("isSameOrBefore: Invalid unit!");
      }, t.prototype.isAfter = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            return this.getTime() > t.getTime();

          case "day":
          case "days":
            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();

          case "month":
          case "months":
            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(t.getFullYear(), t.getMonth(), 1).getTime();

          case "year":
          case "years":
            return this.getFullYear() > t.getFullYear();
        }

        throw new Error("isAfter: Invalid unit!");
      }, t.prototype.isSameOrAfter = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            return this.getTime() >= t.getTime();

          case "day":
          case "days":
            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();

          case "month":
          case "months":
            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(t.getFullYear(), t.getMonth(), 1).getTime();
        }

        throw new Error("isSameOrAfter: Invalid unit!");
      }, t.prototype.isSame = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            return this.getTime() === t.getTime();

          case "day":
          case "days":
            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();

          case "month":
          case "months":
            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(t.getFullYear(), t.getMonth(), 1).getTime();
        }

        throw new Error("isSame: Invalid unit!");
      }, t.prototype.add = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            this.setSeconds(this.getSeconds() + t);
            break;

          case "day":
          case "days":
            this.setDate(this.getDate() + t);
            break;

          case "month":
          case "months":
            this.setMonth(this.getMonth() + t);
        }

        return this || _global;
      }, t.prototype.subtract = function (t, e) {
        switch (void 0 === e && (e = "seconds"), e) {
          case "second":
          case "seconds":
            this.setSeconds(this.getSeconds() - t);
            break;

          case "day":
          case "days":
            this.setDate(this.getDate() - t);
            break;

          case "month":
          case "months":
            this.setMonth(this.getMonth() - t);
        }

        return this || _global;
      }, t.prototype.diff = function (t, e) {
        void 0 === e && (e = "seconds");

        switch (e) {
          default:
          case "second":
          case "seconds":
            return this.getTime() - t.getTime();

          case "day":
          case "days":
            return Math.round((this.timestamp() - t.getTime()) / 86400000);

          case "month":
          case "months":
        }
      }, t.prototype.format = function (e, i) {
        if (void 0 === i && (i = "en-US"), "object" == typeof e) return e.output(this.clone().toJSDate());

        for (var n = "", o = [], s = null; null != (s = t.regex.exec(e));) "\\" !== s[1] && o.push(s);

        if (o.length) {
          o[0].index > 0 && (n += e.substring(0, o[0].index));

          for (var r = 0, a = Object.entries(o); r < a.length; r++) {
            var l = a[r],
                c = l[0],
                h = l[1],
                p = Number(c);
            n += this.formatTokens(h[0], i), o[p + 1] && (n += e.substring(h.index + h[0].length, o[p + 1].index)), p === o.length - 1 && (n += e.substring(h.index + h[0].length));
          }
        }

        return n.replace(/\\/g, "");
      }, t.prototype.timestamp = function () {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
      }, t.prototype.formatTokens = function (e, i) {
        switch (e) {
          case "YY":
            return String(this.getFullYear()).slice(-2);

          case "YYYY":
            return String(this.getFullYear());

          case "M":
            return String(this.getMonth() + 1);

          case "MM":
            return ("0" + (this.getMonth() + 1)).slice(-2);

          case "MMM":
            return t.shortMonths(i)[this.getMonth()];

          case "MMMM":
            return t.longMonths(i)[this.getMonth()];

          case "D":
            return String(this.getDate());

          case "DD":
            return ("0" + this.getDate()).slice(-2);

          default:
            return "";
        }
      }, t.regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|d{1,4})/g, t.MONTH_JS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], t;
    }();

    e.DateTime = n;
  }, function (t, e, i) {
    "use strict";

    var n,
        o = (this || _global) && (this || _global).__extends || (n = function (t, e) {
      return (n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
      })(t, e);
    }, function (t, e) {
      function i() {
        (this || _global).constructor = t;
      }

      n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
    }),
        s = (this || _global) && (this || _global).__spreadArrays || function () {
      for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;

      var n = Array(t),
          o = 0;

      for (e = 0; e < i; e++) for (var s = arguments[e], r = 0, a = s.length; r < a; r++, o++) n[o] = s[r];

      return n;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(5),
        a = i(0),
        l = i(3),
        c = i(2),
        h = function (t) {
      function e(e) {
        var i = t.call(this || _global, e) || this || _global;

        return i.preventClick = !1, i.bindEvents(), i;
      }

      return o(e, t), e.prototype.scrollToDate = function (t) {
        if ((this || _global).options.scrollToDate) {
          var e = (this || _global).options.startDate instanceof a.DateTime ? (this || _global).options.startDate.clone() : null,
              i = (this || _global).options.endDate instanceof a.DateTime ? (this || _global).options.endDate.clone() : null;
          !(this || _global).options.startDate || t && t !== (this || _global).options.element ? t && (this || _global).options.endDate && t === (this || _global).options.elementEnd && (i.setDate(1), (this || _global).options.numberOfMonths > 1 && i.isAfter(e) && i.setMonth(i.getMonth() - ((this || _global).options.numberOfMonths - 1)), (this || _global).calendars[0] = i.clone()) : (e.setDate(1), (this || _global).calendars[0] = e.clone());
        }
      }, e.prototype.bindEvents = function () {
        document.addEventListener("click", (this || _global).onClick.bind(this || _global), !0), (this || _global).ui = document.createElement("div"), (this || _global).ui.className = l.litepicker, (this || _global).ui.style.display = "none", (this || _global).ui.addEventListener("mouseenter", (this || _global).onMouseEnter.bind(this || _global), !0), (this || _global).ui.addEventListener("mouseleave", (this || _global).onMouseLeave.bind(this || _global), !1), (this || _global).options.autoRefresh ? ((this || _global).options.element instanceof HTMLElement && (this || _global).options.element.addEventListener("keyup", (this || _global).onInput.bind(this || _global), !0), (this || _global).options.elementEnd instanceof HTMLElement && (this || _global).options.elementEnd.addEventListener("keyup", (this || _global).onInput.bind(this || _global), !0)) : ((this || _global).options.element instanceof HTMLElement && (this || _global).options.element.addEventListener("change", (this || _global).onInput.bind(this || _global), !0), (this || _global).options.elementEnd instanceof HTMLElement && (this || _global).options.elementEnd.addEventListener("change", (this || _global).onInput.bind(this || _global), !0)), (this || _global).options.parentEl ? (this || _global).options.parentEl instanceof HTMLElement ? (this || _global).options.parentEl.appendChild((this || _global).ui) : document.querySelector((this || _global).options.parentEl).appendChild((this || _global).ui) : (this || _global).options.inlineMode ? (this || _global).options.element instanceof HTMLInputElement ? (this || _global).options.element.parentNode.appendChild((this || _global).ui) : (this || _global).options.element.appendChild((this || _global).ui) : document.body.appendChild((this || _global).ui), this.updateInput(), this.init(), "function" == typeof (this || _global).options.setup && (this || _global).options.setup.call(this || _global, this || _global), this.render(), (this || _global).options.inlineMode && this.show();
      }, e.prototype.updateInput = function () {
        if ((this || _global).options.element instanceof HTMLInputElement) {
          var t = (this || _global).options.startDate,
              e = (this || _global).options.endDate;
          if ((this || _global).options.singleMode && t) (this || _global).options.element.value = t.format((this || _global).options.format, (this || _global).options.lang);else if (!(this || _global).options.singleMode && t && e) {
            var i = t.format((this || _global).options.format, (this || _global).options.lang),
                n = e.format((this || _global).options.format, (this || _global).options.lang);
            (this || _global).options.elementEnd instanceof HTMLInputElement ? ((this || _global).options.element.value = i, (this || _global).options.elementEnd.value = n) : (this || _global).options.element.value = "" + i + (this || _global).options.delimiter + n;
          }
          t || e || ((this || _global).options.element.value = "", (this || _global).options.elementEnd instanceof HTMLInputElement && ((this || _global).options.elementEnd.value = ""));
        }
      }, e.prototype.isSamePicker = function (t) {
        return t.closest("." + l.litepicker) === (this || _global).ui;
      }, e.prototype.shouldShown = function (t) {
        return !t.disabled && (t === (this || _global).options.element || (this || _global).options.elementEnd && t === (this || _global).options.elementEnd);
      }, e.prototype.shouldResetDatePicked = function () {
        return (this || _global).options.singleMode || 2 === (this || _global).datePicked.length;
      }, e.prototype.shouldSwapDatePicked = function () {
        return 2 === (this || _global).datePicked.length && (this || _global).datePicked[0].getTime() > (this || _global).datePicked[1].getTime();
      }, e.prototype.shouldCheckLockDays = function () {
        return (this || _global).options.disallowLockDaysInRange && 2 === (this || _global).datePicked.length;
      }, e.prototype.onClick = function (t) {
        var e = t.target;
        if (e && (this || _global).ui) if (this.shouldShown(e)) this.show(e);else if (e.closest("." + l.litepicker) || !this.isShowning()) {
          if (this.isSamePicker(e)) if (this.emit("before:click", e), (this || _global).preventClick) (this || _global).preventClick = !1;else {
            if (e.classList.contains(l.dayItem)) {
              if (t.preventDefault(), e.classList.contains(l.isLocked)) return;

              if (this.shouldResetDatePicked() && ((this || _global).datePicked.length = 0), (this || _global).datePicked[(this || _global).datePicked.length] = new a.DateTime(e.dataset.time), this.shouldSwapDatePicked()) {
                var i = (this || _global).datePicked[1].clone();

                (this || _global).datePicked[1] = (this || _global).datePicked[0].clone(), (this || _global).datePicked[0] = i.clone();
              }

              if (this.shouldCheckLockDays()) c.rangeIsLocked((this || _global).datePicked, (this || _global).options) && (this.emit("error:range", (this || _global).datePicked), (this || _global).datePicked.length = 0);
              return this.render(), (this || _global).emit.apply(this || _global, s(["preselect"], s((this || _global).datePicked).map(function (t) {
                return t.clone();
              }))), void ((this || _global).options.autoApply && ((this || _global).options.singleMode && (this || _global).datePicked.length ? (this.setDate((this || _global).datePicked[0]), this.hide()) : (this || _global).options.singleMode || 2 !== (this || _global).datePicked.length || (this.setDateRange((this || _global).datePicked[0], (this || _global).datePicked[1]), this.hide())));
            }

            if (e.classList.contains(l.buttonPreviousMonth)) {
              t.preventDefault();
              var n = 0,
                  o = (this || _global).options.switchingMonths || (this || _global).options.numberOfMonths;

              if ((this || _global).options.splitView) {
                var r = e.closest("." + l.monthItem);
                n = c.findNestedMonthItem(r), o = 1;
              }

              return (this || _global).calendars[n].setMonth((this || _global).calendars[n].getMonth() - o), this.gotoDate((this || _global).calendars[n], n), void this.emit("change:month", (this || _global).calendars[n], n);
            }

            if (e.classList.contains(l.buttonNextMonth)) {
              t.preventDefault();
              n = 0, o = (this || _global).options.switchingMonths || (this || _global).options.numberOfMonths;

              if ((this || _global).options.splitView) {
                r = e.closest("." + l.monthItem);
                n = c.findNestedMonthItem(r), o = 1;
              }

              return (this || _global).calendars[n].setMonth((this || _global).calendars[n].getMonth() + o), this.gotoDate((this || _global).calendars[n], n), void this.emit("change:month", (this || _global).calendars[n], n);
            }

            e.classList.contains(l.buttonCancel) && (t.preventDefault(), this.hide(), this.emit("button:cancel")), e.classList.contains(l.buttonApply) && (t.preventDefault(), (this || _global).options.singleMode && (this || _global).datePicked.length ? this.setDate((this || _global).datePicked[0]) : (this || _global).options.singleMode || 2 !== (this || _global).datePicked.length || this.setDateRange((this || _global).datePicked[0], (this || _global).datePicked[1]), this.hide(), this.emit("button:apply", (this || _global).options.startDate, (this || _global).options.endDate));
          }
        } else this.hide();
      }, e.prototype.showTooltip = function (t, e) {
        var i = (this || _global).ui.querySelector("." + l.containerTooltip);

        i.style.visibility = "visible", i.innerHTML = e;

        var n = (this || _global).ui.getBoundingClientRect(),
            o = i.getBoundingClientRect(),
            s = t.getBoundingClientRect(),
            r = s.top,
            a = s.left;

        if ((this || _global).options.inlineMode && (this || _global).options.parentEl) {
          var c = (this || _global).ui.parentNode.getBoundingClientRect();

          r -= c.top, a -= c.left;
        } else r -= n.top, a -= n.left;

        r -= o.height, a -= o.width / 2, a += s.width / 2, i.style.top = r + "px", i.style.left = a + "px", this.emit("tooltip", i, t);
      }, e.prototype.hideTooltip = function () {
        (this || _global).ui.querySelector("." + l.containerTooltip).style.visibility = "hidden";
      }, e.prototype.shouldAllowMouseEnter = function (t) {
        return !(this || _global).options.singleMode && !t.classList.contains(l.isLocked);
      }, e.prototype.shouldAllowRepick = function () {
        return (this || _global).options.elementEnd && (this || _global).options.allowRepick && (this || _global).options.startDate && (this || _global).options.endDate;
      }, e.prototype.isDayItem = function (t) {
        return t.classList.contains(l.dayItem);
      }, e.prototype.onMouseEnter = function (t) {
        var e = this || _global,
            i = t.target;

        if (this.isDayItem(i) && this.shouldAllowMouseEnter(i)) {
          if (this.shouldAllowRepick() && ((this || _global).triggerElement === (this || _global).options.element ? (this || _global).datePicked[0] = (this || _global).options.endDate.clone() : (this || _global).triggerElement === (this || _global).options.elementEnd && ((this || _global).datePicked[0] = (this || _global).options.startDate.clone())), 1 !== (this || _global).datePicked.length) return;

          var n = (this || _global).ui.querySelector("." + l.dayItem + "[data-time=\"" + (this || _global).datePicked[0].getTime() + "\"]"),
              o = (this || _global).datePicked[0].clone(),
              s = new a.DateTime(i.dataset.time),
              r = !1;

          if (o.getTime() > s.getTime()) {
            var c = o.clone();
            o = s.clone(), s = c.clone(), r = !0;
          }

          if (Array.prototype.slice.call((this || _global).ui.querySelectorAll("." + l.dayItem)).forEach(function (t) {
            var i = new a.DateTime(t.dataset.time),
                n = e.renderDay(i);
            i.isBetween(o, s) && n.classList.add(l.isInRange), t.className = n.className;
          }), i.classList.add(l.isEndDate), r ? (n && n.classList.add(l.isFlipped), i.classList.add(l.isFlipped)) : (n && n.classList.remove(l.isFlipped), i.classList.remove(l.isFlipped)), (this || _global).options.showTooltip) {
            var h = s.diff(o, "day") + 1;

            if ("function" == typeof (this || _global).options.tooltipNumber && (h = (this || _global).options.tooltipNumber.call(this || _global, h)), h > 0) {
              var p = this.pluralSelector(h),
                  d = h + " " + ((this || _global).options.tooltipText[p] ? (this || _global).options.tooltipText[p] : "[" + p + "]");
              this.showTooltip(i, d);
              var u = window.navigator.userAgent,
                  m = /(iphone|ipad)/i.test(u),
                  f = /OS 1([0-2])/i.test(u);
              m && f && i.dispatchEvent(new Event("click"));
            } else this.hideTooltip();
          }
        }
      }, e.prototype.onMouseLeave = function (t) {
        t.target;
        (this || _global).options.allowRepick && (!(this || _global).options.allowRepick || (this || _global).options.startDate || (this || _global).options.endDate) && ((this || _global).datePicked.length = 0, this.render());
      }, e.prototype.onInput = function (t) {
        var e = this.parseInput(),
            i = e[0],
            n = e[1],
            o = (this || _global).options.format;

        if ((this || _global).options.elementEnd ? i instanceof a.DateTime && n instanceof a.DateTime && i.format(o) === (this || _global).options.element.value && n.format(o) === (this || _global).options.elementEnd.value : (this || _global).options.singleMode ? i instanceof a.DateTime && i.format(o) === (this || _global).options.element.value : i instanceof a.DateTime && n instanceof a.DateTime && "" + i.format(o) + (this || _global).options.delimiter + n.format(o) === (this || _global).options.element.value) {
          if (n && i.getTime() > n.getTime()) {
            var s = i.clone();
            i = n.clone(), n = s.clone();
          }

          (this || _global).options.startDate = new a.DateTime(i, (this || _global).options.format, (this || _global).options.lang), n && ((this || _global).options.endDate = new a.DateTime(n, (this || _global).options.format, (this || _global).options.lang)), this.updateInput(), this.render();
          var r = i.clone(),
              l = 0;
          ((this || _global).options.elementEnd ? i.format(o) === t.target.value : t.target.value.startsWith(i.format(o))) || (r = n.clone(), l = (this || _global).options.numberOfMonths - 1), this.emit("selected", this.getStartDate(), this.getEndDate()), this.gotoDate(r, l);
        }
      }, e;
    }(r.Calendar);

    e.Litepicker = h;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.findNestedMonthItem = function (t) {
      for (var e = t.parentNode.childNodes, i = 0; i < e.length; i += 1) {
        if (e.item(i) === t) return i;
      }

      return 0;
    }, e.dateIsLocked = function (t, e, i) {
      var n = !1;
      return e.lockDays.length && (n = e.lockDays.filter(function (i) {
        return i instanceof Array ? t.isBetween(i[0], i[1], e.lockDaysInclusivity) : i.isSame(t, "day");
      }).length), n || "function" != typeof e.lockDaysFilter || (n = e.lockDaysFilter.call(this || _global, t.clone(), null, i)), n;
    }, e.rangeIsLocked = function (t, e) {
      var i = !1;
      return e.lockDays.length && (i = e.lockDays.filter(function (i) {
        if (i instanceof Array) {
          var n = t[0].toDateString() === i[0].toDateString() && t[1].toDateString() === i[1].toDateString();
          return i[0].isBetween(t[0], t[1], e.lockDaysInclusivity) || i[1].isBetween(t[0], t[1], e.lockDaysInclusivity) || n;
        }

        return i.isBetween(t[0], t[1], e.lockDaysInclusivity);
      }).length), i || "function" != typeof e.lockDaysFilter || (i = e.lockDaysFilter.call(this || _global, t[0].clone(), t[1].clone(), t)), i;
    };
  }, function (t, e, i) {
    var n = i(8);
    "string" == typeof n && (n = [[t.i, n, ""]]);
    var o = {
      insert: function (t) {
        var e = document.querySelector("head"),
            i = window._lastElementInsertedByStyleLoader;
        window.disableLitepickerStyles || (i ? i.nextSibling ? e.insertBefore(t, i.nextSibling) : e.appendChild(t) : e.insertBefore(t, e.firstChild), window._lastElementInsertedByStyleLoader = t);
      },
      singleton: !1
    };
    i(10)(n, o);
    n.locals && (t.exports = n.locals);
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = i(1);
    e.Litepicker = n.Litepicker, i(11), window.Litepicker = n.Litepicker, e.default = n.Litepicker;
  }, function (t, e, i) {
    "use strict";

    var n,
        o = (this || _global) && (this || _global).__extends || (n = function (t, e) {
      return (n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
      })(t, e);
    }, function (t, e) {
      function i() {
        (this || _global).constructor = t;
      }

      n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
    });
    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var s = i(6),
        r = i(0),
        a = i(3),
        l = i(2),
        c = function (t) {
      function e(e) {
        return t.call(this || _global, e) || this || _global;
      }

      return o(e, t), e.prototype.render = function () {
        var t = this || _global;
        this.emit("before:render", (this || _global).ui);
        var e = document.createElement("div");
        e.className = a.containerMain;
        var i = document.createElement("div");
        i.className = a.containerMonths, a["columns" + (this || _global).options.numberOfColumns] && (i.classList.remove(a.columns2, a.columns3, a.columns4), i.classList.add(a["columns" + (this || _global).options.numberOfColumns])), (this || _global).options.splitView && i.classList.add(a.splitView), (this || _global).options.showWeekNumbers && i.classList.add(a.showWeekNumbers);

        for (var n = (this || _global).calendars[0].clone(), o = n.getMonth(), s = n.getMonth() + (this || _global).options.numberOfMonths, r = 0, l = o; l < s; l += 1) {
          var c = n.clone();
          c.setDate(1), c.setHours(0, 0, 0, 0), (this || _global).options.splitView ? c = (this || _global).calendars[r].clone() : c.setMonth(l), i.appendChild(this.renderMonth(c, r)), r += 1;
        }

        if ((this || _global).ui.innerHTML = "", e.appendChild(i), (this || _global).options.resetButton) {
          var h = void 0;
          "function" == typeof (this || _global).options.resetButton ? h = (this || _global).options.resetButton.call(this || _global) : ((h = document.createElement("button")).type = "button", h.className = a.resetButton, h.innerHTML = (this || _global).options.buttonText.reset), h.addEventListener("click", function (e) {
            e.preventDefault(), t.clearSelection();
          }), e.querySelector("." + a.monthItem + ":last-child").querySelector("." + a.monthItemHeader).appendChild(h);
        }

        (this || _global).ui.appendChild(e), (this || _global).options.autoApply && !(this || _global).options.footerHTML || (this || _global).ui.appendChild(this.renderFooter()), (this || _global).options.showTooltip && (this || _global).ui.appendChild(this.renderTooltip()), (this || _global).ui.dataset.plugins = ((this || _global).options.plugins || []).join("|"), this.emit("render", (this || _global).ui);
      }, e.prototype.renderMonth = function (t, e) {
        var i = this || _global,
            n = t.clone(),
            o = 32 - new Date(n.getFullYear(), n.getMonth(), 32).getDate(),
            s = document.createElement("div");
        s.className = a.monthItem;
        var c = document.createElement("div");
        c.className = a.monthItemHeader;
        var h = document.createElement("div");

        if ((this || _global).options.dropdowns.months) {
          var p = document.createElement("select");
          p.className = a.monthItemName;

          for (var d = 0; d < 12; d += 1) {
            var u = document.createElement("option"),
                m = new r.DateTime(new Date(t.getFullYear(), d, 2, 0, 0, 0)),
                f = new r.DateTime(new Date(t.getFullYear(), d, 1, 0, 0, 0));
            u.value = String(d), u.text = m.toLocaleString((this || _global).options.lang, {
              month: "long"
            }), u.disabled = (this || _global).options.minDate && f.isBefore(new r.DateTime((this || _global).options.minDate), "month") || (this || _global).options.maxDate && f.isAfter(new r.DateTime((this || _global).options.maxDate), "month"), u.selected = f.getMonth() === t.getMonth(), p.appendChild(u);
          }

          p.addEventListener("change", function (t) {
            var e = t.target,
                n = 0;

            if (i.options.splitView) {
              var o = e.closest("." + a.monthItem);
              n = l.findNestedMonthItem(o);
            }

            i.calendars[n].setMonth(Number(e.value)), i.render(), i.emit("change:month", i.calendars[n], n, t);
          }), h.appendChild(p);
        } else {
          (m = document.createElement("strong")).className = a.monthItemName, m.innerHTML = t.toLocaleString((this || _global).options.lang, {
            month: "long"
          }), h.appendChild(m);
        }

        if ((this || _global).options.dropdowns.years) {
          var g = document.createElement("select");
          g.className = a.monthItemYear;
          var v = (this || _global).options.dropdowns.minYear,
              y = (this || _global).options.dropdowns.maxYear ? (this || _global).options.dropdowns.maxYear : new Date().getFullYear();
          if (t.getFullYear() > y) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);

          for (d = y; d >= v; d -= 1) {
            var u = document.createElement("option"),
                b = new r.DateTime(new Date(d, 0, 1, 0, 0, 0));
            u.value = String(d), u.text = String(d), u.disabled = (this || _global).options.minDate && b.isBefore(new r.DateTime((this || _global).options.minDate), "year") || (this || _global).options.maxDate && b.isAfter(new r.DateTime((this || _global).options.maxDate), "year"), u.selected = t.getFullYear() === d, g.appendChild(u);
          }

          if (t.getFullYear() < v) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);

          if ("asc" === (this || _global).options.dropdowns.years) {
            var k = Array.prototype.slice.call(g.childNodes).reverse();
            g.innerHTML = "", k.forEach(function (t) {
              t.innerHTML = t.value, g.appendChild(t);
            });
          }

          g.addEventListener("change", function (t) {
            var e = t.target,
                n = 0;

            if (i.options.splitView) {
              var o = e.closest("." + a.monthItem);
              n = l.findNestedMonthItem(o);
            }

            i.calendars[n].setFullYear(Number(e.value)), i.render(), i.emit("change:year", i.calendars[n], n, t);
          }), h.appendChild(g);
        } else {
          var D = document.createElement("span");
          D.className = a.monthItemYear, D.innerHTML = String(t.getFullYear()), h.appendChild(D);
        }

        var w = document.createElement("button");
        w.type = "button", w.className = a.buttonPreviousMonth, w.innerHTML = (this || _global).options.buttonText.previousMonth;
        var x = document.createElement("button");
        x.type = "button", x.className = a.buttonNextMonth, x.innerHTML = (this || _global).options.buttonText.nextMonth, c.appendChild(w), c.appendChild(h), c.appendChild(x), (this || _global).options.minDate && n.isSameOrBefore(new r.DateTime((this || _global).options.minDate), "month") && s.classList.add(a.noPreviousMonth), (this || _global).options.maxDate && n.isSameOrAfter(new r.DateTime((this || _global).options.maxDate), "month") && s.classList.add(a.noNextMonth);
        var M = document.createElement("div");
        M.className = a.monthItemWeekdaysRow, (this || _global).options.showWeekNumbers && (M.innerHTML = "<div>W</div>");

        for (var _ = 1; _ <= 7; _ += 1) {
          var T = 3 + (this || _global).options.firstDay + _,
              L = document.createElement("div");
          L.innerHTML = this.weekdayName(T), L.title = this.weekdayName(T, "long"), M.appendChild(L);
        }

        var E = document.createElement("div");
        E.className = a.containerDays;
        var S = this.calcSkipDays(n);
        (this || _global).options.showWeekNumbers && S && E.appendChild(this.renderWeekNumber(n));

        for (var I = 0; I < S; I += 1) {
          var P = document.createElement("div");
          E.appendChild(P);
        }

        for (I = 1; I <= o; I += 1) n.setDate(I), (this || _global).options.showWeekNumbers && n.getDay() === (this || _global).options.firstDay && E.appendChild(this.renderWeekNumber(n)), E.appendChild(this.renderDay(n));

        return s.appendChild(c), s.appendChild(M), s.appendChild(E), this.emit("render:month", s, t), s;
      }, e.prototype.renderDay = function (t) {
        t.setHours();
        var e = document.createElement("div");
        if (e.className = a.dayItem, e.innerHTML = String(t.getDate()), e.dataset.time = String(t.getTime()), t.toDateString() === new Date().toDateString() && e.classList.add(a.isToday), (this || _global).datePicked.length) (this || _global).datePicked[0].toDateString() === t.toDateString() && (e.classList.add(a.isStartDate), (this || _global).options.singleMode && e.classList.add(a.isEndDate)), 2 === (this || _global).datePicked.length && (this || _global).datePicked[1].toDateString() === t.toDateString() && e.classList.add(a.isEndDate), 2 === (this || _global).datePicked.length && t.isBetween((this || _global).datePicked[0], (this || _global).datePicked[1]) && e.classList.add(a.isInRange);else if ((this || _global).options.startDate) {
          var i = (this || _global).options.startDate,
              n = (this || _global).options.endDate;
          i.toDateString() === t.toDateString() && (e.classList.add(a.isStartDate), (this || _global).options.singleMode && e.classList.add(a.isEndDate)), n && n.toDateString() === t.toDateString() && e.classList.add(a.isEndDate), i && n && t.isBetween(i, n) && e.classList.add(a.isInRange);
        }

        if ((this || _global).options.minDate && t.isBefore(new r.DateTime((this || _global).options.minDate)) && e.classList.add(a.isLocked), (this || _global).options.maxDate && t.isAfter(new r.DateTime((this || _global).options.maxDate)) && e.classList.add(a.isLocked), (this || _global).options.minDays > 1 && 1 === (this || _global).datePicked.length) {
          var o = (this || _global).options.minDays - 1,
              s = (this || _global).datePicked[0].clone().subtract(o, "day"),
              c = (this || _global).datePicked[0].clone().add(o, "day");

          t.isBetween(s, (this || _global).datePicked[0], "(]") && e.classList.add(a.isLocked), t.isBetween((this || _global).datePicked[0], c, "[)") && e.classList.add(a.isLocked);
        }

        if ((this || _global).options.maxDays && 1 === (this || _global).datePicked.length) {
          var h = (this || _global).options.maxDays;
          s = (this || _global).datePicked[0].clone().subtract(h, "day"), c = (this || _global).datePicked[0].clone().add(h, "day");
          t.isSameOrBefore(s) && e.classList.add(a.isLocked), t.isSameOrAfter(c) && e.classList.add(a.isLocked);
        }

        ((this || _global).options.selectForward && 1 === (this || _global).datePicked.length && t.isBefore((this || _global).datePicked[0]) && e.classList.add(a.isLocked), (this || _global).options.selectBackward && 1 === (this || _global).datePicked.length && t.isAfter((this || _global).datePicked[0]) && e.classList.add(a.isLocked), l.dateIsLocked(t, (this || _global).options, (this || _global).datePicked) && e.classList.add(a.isLocked), (this || _global).options.highlightedDays.length) && (this || _global).options.highlightedDays.filter(function (e) {
          return e instanceof Array ? t.isBetween(e[0], e[1], "[]") : e.isSame(t, "day");
        }).length && e.classList.add(a.isHighlighted);
        return e.tabIndex = e.classList.contains("is-locked") ? -1 : 0, this.emit("render:day", e, t), e;
      }, e.prototype.renderFooter = function () {
        var t = document.createElement("div");

        if (t.className = a.containerFooter, (this || _global).options.footerHTML ? t.innerHTML = (this || _global).options.footerHTML : t.innerHTML = "\n      <span class=\"" + a.previewDateRange + "\"></span>\n      <button type=\"button\" class=\"" + a.buttonCancel + "\">" + (this || _global).options.buttonText.cancel + "</button>\n      <button type=\"button\" class=\"" + a.buttonApply + "\">" + (this || _global).options.buttonText.apply + "</button>\n      ", (this || _global).options.singleMode) {
          if (1 === (this || _global).datePicked.length) {
            var e = (this || _global).datePicked[0].format((this || _global).options.format, (this || _global).options.lang);

            t.querySelector("." + a.previewDateRange).innerHTML = e;
          }
        } else if (1 === (this || _global).datePicked.length && t.querySelector("." + a.buttonApply).setAttribute("disabled", ""), 2 === (this || _global).datePicked.length) {
          e = (this || _global).datePicked[0].format((this || _global).options.format, (this || _global).options.lang);

          var i = (this || _global).datePicked[1].format((this || _global).options.format, (this || _global).options.lang);

          t.querySelector("." + a.previewDateRange).innerHTML = "" + e + (this || _global).options.delimiter + i;
        }

        return this.emit("render:footer", t), t;
      }, e.prototype.renderWeekNumber = function (t) {
        var e = document.createElement("div"),
            i = t.getWeek((this || _global).options.firstDay);
        return e.className = a.weekNumber, e.innerHTML = 53 === i && 0 === t.getMonth() ? "53 / 1" : i, e;
      }, e.prototype.renderTooltip = function () {
        var t = document.createElement("div");
        return t.className = a.containerTooltip, t;
      }, e.prototype.weekdayName = function (t, e) {
        return void 0 === e && (e = "short"), new Date(1970, 0, t, 12, 0, 0, 0).toLocaleString((this || _global).options.lang, {
          weekday: e
        });
      }, e.prototype.calcSkipDays = function (t) {
        var e = t.getDay() - (this || _global).options.firstDay;

        return e < 0 && (e += 7), e;
      }, e;
    }(s.LPCore);

    e.Calendar = c;
  }, function (t, e, i) {
    "use strict";

    var n,
        o = (this || _global) && (this || _global).__extends || (n = function (t, e) {
      return (n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
      })(t, e);
    }, function (t, e) {
      function i() {
        (this || _global).constructor = t;
      }

      n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
    }),
        s = (this || _global) && (this || _global).__assign || function () {
      return (s = Object.assign || function (t) {
        for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);

        return t;
      }).apply(this || _global, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(7),
        a = i(0),
        l = i(1),
        c = function (t) {
      function e(e) {
        var i = t.call(this || _global) || this || _global;

        i.datePicked = [], i.calendars = [], i.options = {
          element: null,
          elementEnd: null,
          parentEl: null,
          firstDay: 1,
          format: "YYYY-MM-DD",
          lang: "en-US",
          delimiter: " - ",
          numberOfMonths: 1,
          numberOfColumns: 1,
          startDate: null,
          endDate: null,
          zIndex: 9999,
          position: "auto",
          selectForward: !1,
          selectBackward: !1,
          splitView: !1,
          inlineMode: !1,
          singleMode: !0,
          autoApply: !0,
          allowRepick: !1,
          showWeekNumbers: !1,
          showTooltip: !0,
          scrollToDate: !0,
          mobileFriendly: !0,
          resetButton: !1,
          autoRefresh: !1,
          lockDaysFormat: "YYYY-MM-DD",
          lockDays: [],
          disallowLockDaysInRange: !1,
          lockDaysInclusivity: "[]",
          highlightedDaysFormat: "YYYY-MM-DD",
          highlightedDays: [],
          dropdowns: {
            minYear: 1990,
            maxYear: null,
            months: !1,
            years: !1
          },
          buttonText: {
            apply: "Apply",
            cancel: "Cancel",
            previousMonth: "<svg width=\"11\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z\" fill-rule=\"nonzero\"/></svg>",
            nextMonth: "<svg width=\"11\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z\" fill-rule=\"nonzero\"/></svg>",
            reset: "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\">\n        <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n        <path d=\"M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z\"/>\n      </svg>"
          },
          tooltipText: {
            one: "day",
            other: "days"
          }
        }, i.options = s(s({}, i.options), e.element.dataset), Object.keys(i.options).forEach(function (t) {
          "true" !== i.options[t] && "false" !== i.options[t] || (i.options[t] = "true" === i.options[t]);
        });
        var n = s(s({}, i.options.dropdowns), e.dropdowns),
            o = s(s({}, i.options.buttonText), e.buttonText),
            r = s(s({}, i.options.tooltipText), e.tooltipText);
        i.options = s(s({}, i.options), e), i.options.dropdowns = s({}, n), i.options.buttonText = s({}, o), i.options.tooltipText = s({}, r), i.options.elementEnd || (i.options.allowRepick = !1), i.options.lockDays.length && (i.options.lockDays = a.DateTime.convertArray(i.options.lockDays, i.options.lockDaysFormat)), i.options.highlightedDays.length && (i.options.highlightedDays = a.DateTime.convertArray(i.options.highlightedDays, i.options.highlightedDaysFormat));
        var l = i.parseInput(),
            c = l[0],
            h = l[1];
        i.options.startDate && (i.options.singleMode || i.options.endDate) && (c = new a.DateTime(i.options.startDate, i.options.format, i.options.lang)), c && i.options.endDate && (h = new a.DateTime(i.options.endDate, i.options.format, i.options.lang)), c instanceof a.DateTime && !isNaN(c.getTime()) && (i.options.startDate = c), i.options.startDate && h instanceof a.DateTime && !isNaN(h.getTime()) && (i.options.endDate = h), !i.options.singleMode || i.options.startDate instanceof a.DateTime || (i.options.startDate = null), i.options.singleMode || i.options.startDate instanceof a.DateTime && i.options.endDate instanceof a.DateTime || (i.options.startDate = null, i.options.endDate = null);

        for (var p = 0; p < i.options.numberOfMonths; p += 1) {
          var d = i.options.startDate instanceof a.DateTime ? i.options.startDate.clone() : new a.DateTime();

          if (!i.options.startDate && (0 === p || i.options.splitView)) {
            var u = i.options.maxDate ? new a.DateTime(i.options.maxDate) : null,
                m = i.options.minDate ? new a.DateTime(i.options.minDate) : null,
                f = i.options.numberOfMonths - 1;
            m && u && d.isAfter(u) ? (d = m.clone()).setDate(1) : !m && u && d.isAfter(u) && ((d = u.clone()).setDate(1), d.setMonth(d.getMonth() - f));
          }

          d.setDate(1), d.setMonth(d.getMonth() + p), i.calendars[p] = d;
        }

        if (i.options.showTooltip) if (i.options.tooltipPluralSelector) i.pluralSelector = i.options.tooltipPluralSelector;else try {
          var g = new Intl.PluralRules(i.options.lang);
          i.pluralSelector = g.select.bind(g);
        } catch (t) {
          i.pluralSelector = function (t) {
            return 0 === Math.abs(t) ? "one" : "other";
          };
        }
        return i;
      }

      return o(e, t), e.add = function (t, e) {
        l.Litepicker.prototype[t] = e;
      }, e.prototype.DateTime = function (t, e) {
        return t ? new a.DateTime(t, e) : new a.DateTime();
      }, e.prototype.init = function () {
        var t = this || _global;
        (this || _global).options.plugins && (this || _global).options.plugins.length && (this || _global).options.plugins.forEach(function (e) {
          l.Litepicker.prototype.hasOwnProperty(e) ? l.Litepicker.prototype[e].init.call(t, t) : console.warn("Litepicker: plugin \xAB" + e + "\xBB not found.");
        });
      }, e.prototype.parseInput = function () {
        var t = (this || _global).options.delimiter,
            e = new RegExp("" + t),
            i = (this || _global).options.element instanceof HTMLInputElement ? (this || _global).options.element.value.split(t) : [];

        if ((this || _global).options.elementEnd) {
          if ((this || _global).options.element instanceof HTMLInputElement && (this || _global).options.element.value.length && (this || _global).options.elementEnd instanceof HTMLInputElement && (this || _global).options.elementEnd.value.length) return [new a.DateTime((this || _global).options.element.value, (this || _global).options.format), new a.DateTime((this || _global).options.elementEnd.value, (this || _global).options.format)];
        } else if ((this || _global).options.singleMode) {
          if ((this || _global).options.element instanceof HTMLInputElement && (this || _global).options.element.value.length) return [new a.DateTime((this || _global).options.element.value, (this || _global).options.format)];
        } else if ((this || _global).options.element instanceof HTMLInputElement && e.test((this || _global).options.element.value) && i.length && i.length % 2 == 0) {
          var n = i.slice(0, i.length / 2).join(t),
              o = i.slice(i.length / 2).join(t);
          return [new a.DateTime(n, (this || _global).options.format), new a.DateTime(o, (this || _global).options.format)];
        }

        return [];
      }, e.prototype.isShowning = function () {
        return (this || _global).ui && "none" !== (this || _global).ui.style.display;
      }, e.prototype.findPosition = function (t) {
        var e = t.getBoundingClientRect(),
            i = (this || _global).ui.getBoundingClientRect(),
            n = (this || _global).options.position.split(" "),
            o = window.scrollX || window.pageXOffset,
            s = window.scrollY || window.pageYOffset,
            r = 0,
            a = 0;

        if ("auto" !== n[0] && /top|bottom/.test(n[0])) r = e[n[0]] + s, "top" === n[0] && (r -= i.height);else {
          r = e.bottom + s;
          var l = e.bottom + i.height > window.innerHeight,
              c = e.top + s - i.height >= i.height;
          l && c && (r = e.top + s - i.height);
        }
        if (/left|right/.test(n[0]) || n[1] && "auto" !== n[1] && /left|right/.test(n[1])) a = /left|right/.test(n[0]) ? e[n[0]] + o : e[n[1]] + o, "right" !== n[0] && "right" !== n[1] || (a -= i.width);else {
          a = e.left + o;
          l = e.left + i.width > window.innerWidth;
          var h = e.right + o - i.width >= 0;
          l && h && (a = e.right + o - i.width);
        }
        return {
          left: a,
          top: r
        };
      }, e;
    }(r.EventEmitter);

    e.LPCore = c;
  }, function (t, e, i) {
    "use strict";

    var n,
        o = "object" == typeof Reflect ? Reflect : null,
        s = o && "function" == typeof o.apply ? o.apply : function (t, e, i) {
      return Function.prototype.apply.call(t, e, i);
    };
    n = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var r = Number.isNaN || function (t) {
      return t != t;
    };

    function a() {
      a.init.call(this || _global);
    }

    t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
    var l = 10;

    function c(t) {
      return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
    }

    function h(t, e, i, n) {
      var o, s, r, a;
      if ("function" != typeof i) throw new TypeError("The \"listener\" argument must be of type Function. Received type " + typeof i);
      if (void 0 === (s = t._events) ? (s = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== s.newListener && (t.emit("newListener", e, i.listener ? i.listener : i), s = t._events), r = s[e]), void 0 === r) r = s[e] = i, ++t._eventsCount;else if ("function" == typeof r ? r = s[e] = n ? [i, r] : [r, i] : n ? r.unshift(i) : r.push(i), (o = c(t)) > 0 && r.length > o && !r.warned) {
        r.warned = !0;
        var l = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = r.length, a = l, console && console.warn && console.warn(a);
      }
      return t;
    }

    function p() {
      for (var t = [], e = 0; e < arguments.length; e++) t.push(arguments[e]);

      (this || _global).fired || ((this || _global).target.removeListener((this || _global).type, (this || _global).wrapFn), (this || _global).fired = !0, s((this || _global).listener, (this || _global).target, t));
    }

    function d(t, e, i) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: i
      },
          o = p.bind(n);
      return o.listener = i, n.wrapFn = o, o;
    }

    function u(t, e, i) {
      var n = t._events;
      if (void 0 === n) return [];
      var o = n[e];
      return void 0 === o ? [] : "function" == typeof o ? i ? [o.listener || o] : [o] : i ? function (t) {
        for (var e = new Array(t.length), i = 0; i < e.length; ++i) e[i] = t[i].listener || t[i];

        return e;
      }(o) : f(o, o.length);
    }

    function m(t) {
      var e = (this || _global)._events;

      if (void 0 !== e) {
        var i = e[t];
        if ("function" == typeof i) return 1;
        if (void 0 !== i) return i.length;
      }

      return 0;
    }

    function f(t, e) {
      for (var i = new Array(e), n = 0; n < e; ++n) i[n] = t[n];

      return i;
    }

    Object.defineProperty(a, "defaultMaxListeners", {
      enumerable: !0,
      get: function () {
        return l;
      },
      set: function (t) {
        if ("number" != typeof t || t < 0 || r(t)) throw new RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + t + ".");
        l = t;
      }
    }), a.init = function () {
      void 0 !== (this || _global)._events && (this || _global)._events !== Object.getPrototypeOf(this || _global)._events || ((this || _global)._events = Object.create(null), (this || _global)._eventsCount = 0), (this || _global)._maxListeners = (this || _global)._maxListeners || void 0;
    }, a.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || r(t)) throw new RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + t + ".");
      return (this || _global)._maxListeners = t, this || _global;
    }, a.prototype.getMaxListeners = function () {
      return c(this || _global);
    }, a.prototype.emit = function (t) {
      for (var e = [], i = 1; i < arguments.length; i++) e.push(arguments[i]);

      var n = "error" === t,
          o = (this || _global)._events;
      if (void 0 !== o) n = n && void 0 === o.error;else if (!n) return !1;

      if (n) {
        var r;
        if (e.length > 0 && (r = e[0]), r instanceof Error) throw r;
        var a = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
        throw a.context = r, a;
      }

      var l = o[t];
      if (void 0 === l) return !1;
      if ("function" == typeof l) s(l, this || _global, e);else {
        var c = l.length,
            h = f(l, c);

        for (i = 0; i < c; ++i) s(h[i], this || _global, e);
      }
      return !0;
    }, a.prototype.addListener = function (t, e) {
      return h(this || _global, t, e, !1);
    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (t, e) {
      return h(this || _global, t, e, !0);
    }, a.prototype.once = function (t, e) {
      if ("function" != typeof e) throw new TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
      return this.on(t, d(this || _global, t, e)), this || _global;
    }, a.prototype.prependOnceListener = function (t, e) {
      if ("function" != typeof e) throw new TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
      return this.prependListener(t, d(this || _global, t, e)), this || _global;
    }, a.prototype.removeListener = function (t, e) {
      var i, n, o, s, r;
      if ("function" != typeof e) throw new TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
      if (void 0 === (n = (this || _global)._events)) return this || _global;
      if (void 0 === (i = n[t])) return this || _global;
      if (i === e || i.listener === e) 0 == --(this || _global)._eventsCount ? (this || _global)._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, i.listener || e));else if ("function" != typeof i) {
        for (o = -1, s = i.length - 1; s >= 0; s--) if (i[s] === e || i[s].listener === e) {
          r = i[s].listener, o = s;
          break;
        }

        if (o < 0) return this || _global;
        0 === o ? i.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) t[e] = t[e + 1];

          t.pop();
        }(i, o), 1 === i.length && (n[t] = i[0]), void 0 !== n.removeListener && this.emit("removeListener", t, r || e);
      }
      return this || _global;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (t) {
      var e, i, n;
      if (void 0 === (i = (this || _global)._events)) return this || _global;
      if (void 0 === i.removeListener) return 0 === arguments.length ? ((this || _global)._events = Object.create(null), (this || _global)._eventsCount = 0) : void 0 !== i[t] && (0 == --(this || _global)._eventsCount ? (this || _global)._events = Object.create(null) : delete i[t]), this || _global;

      if (0 === arguments.length) {
        var o,
            s = Object.keys(i);

        for (n = 0; n < s.length; ++n) "removeListener" !== (o = s[n]) && this.removeAllListeners(o);

        return this.removeAllListeners("removeListener"), (this || _global)._events = Object.create(null), (this || _global)._eventsCount = 0, this || _global;
      }

      if ("function" == typeof (e = i[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) this.removeListener(t, e[n]);
      return this || _global;
    }, a.prototype.listeners = function (t) {
      return u(this || _global, t, !0);
    }, a.prototype.rawListeners = function (t) {
      return u(this || _global, t, !1);
    }, a.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : m.call(t, e);
    }, a.prototype.listenerCount = m, a.prototype.eventNames = function () {
      return (this || _global)._eventsCount > 0 ? n((this || _global)._events) : [];
    };
  }, function (t, e, i) {
    (e = i(9)(!1)).push([t.i, ":root{--litepicker-container-months-color-bg: #fff;--litepicker-container-months-box-shadow-color: #ddd;--litepicker-footer-color-bg: #fafafa;--litepicker-footer-box-shadow-color: #ddd;--litepicker-tooltip-color-bg: #fff;--litepicker-month-header-color: #333;--litepicker-button-prev-month-color: #9e9e9e;--litepicker-button-next-month-color: #9e9e9e;--litepicker-button-prev-month-color-hover: #2196f3;--litepicker-button-next-month-color-hover: #2196f3;--litepicker-month-width: calc(var(--litepicker-day-width) * 7);--litepicker-month-weekday-color: #9e9e9e;--litepicker-month-week-number-color: #9e9e9e;--litepicker-day-width: 38px;--litepicker-day-color: #333;--litepicker-day-color-hover: #2196f3;--litepicker-is-today-color: #f44336;--litepicker-is-in-range-color: #bbdefb;--litepicker-is-locked-color: #9e9e9e;--litepicker-is-start-color: #fff;--litepicker-is-start-color-bg: #2196f3;--litepicker-is-end-color: #fff;--litepicker-is-end-color-bg: #2196f3;--litepicker-button-cancel-color: #fff;--litepicker-button-cancel-color-bg: #9e9e9e;--litepicker-button-apply-color: #fff;--litepicker-button-apply-color-bg: #2196f3;--litepicker-button-reset-color: #909090;--litepicker-button-reset-color-hover: #2196f3;--litepicker-highlighted-day-color: #333;--litepicker-highlighted-day-color-bg: #ffeb3b}.show-week-numbers{--litepicker-month-width: calc(var(--litepicker-day-width) * 8)}.litepicker{font-family:-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;font-size:0.8em;display:none}.litepicker button{border:none;background:none}.litepicker .container__main{display:-webkit-box;display:-ms-flexbox;display:flex}.litepicker .container__months{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:var(--litepicker-container-months-color-bg);border-radius:5px;-webkit-box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);width:calc(var(--litepicker-month-width) + 10px);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months.columns-2{width:calc((var(--litepicker-month-width) * 2) + 20px)}.litepicker .container__months.columns-3{width:calc((var(--litepicker-month-width) * 3) + 30px)}.litepicker .container__months.columns-4{width:calc((var(--litepicker-month-width) * 4) + 40px)}.litepicker .container__months.split-view .month-item-header .button-previous-month,.litepicker .container__months.split-view .month-item-header .button-next-month{visibility:visible}.litepicker .container__months .month-item{padding:5px;width:var(--litepicker-month-width);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months .month-item-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:500;padding:10px 5px;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--litepicker-month-header-color)}.litepicker .container__months .month-item-header div{-webkit-box-flex:1;-ms-flex:1;flex:1}.litepicker .container__months .month-item-header div>.month-item-name{margin-right:5px}.litepicker .container__months .month-item-header div>.month-item-year{padding:0}.litepicker .container__months .month-item-header .reset-button{color:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button>svg{fill:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button *{pointer-events:none}.litepicker .container__months .month-item-header .reset-button:hover{color:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .reset-button:hover>svg{fill:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .button-previous-month,.litepicker .container__months .month-item-header .button-next-month{visibility:hidden;text-decoration:none;padding:3px 5px;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__months .month-item-header .button-previous-month *,.litepicker .container__months .month-item-header .button-next-month *{pointer-events:none}.litepicker .container__months .month-item-header .button-previous-month{color:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month>svg,.litepicker .container__months .month-item-header .button-previous-month>img{fill:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month:hover{color:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-previous-month:hover>svg{fill:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month{color:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month>svg,.litepicker .container__months .month-item-header .button-next-month>img{fill:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month:hover{color:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month:hover>svg{fill:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-weekdays-row{display:-webkit-box;display:-ms-flexbox;display:flex;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;color:var(--litepicker-month-weekday-color)}.litepicker .container__months .month-item-weekdays-row>div{padding:5px 0;font-size:85%;-webkit-box-flex:1;-ms-flex:1;flex:1;width:var(--litepicker-day-width);text-align:center}.litepicker .container__months .month-item:first-child .button-previous-month{visibility:visible}.litepicker .container__months .month-item:last-child .button-next-month{visibility:visible}.litepicker .container__months .month-item.no-previous-month .button-previous-month{visibility:hidden}.litepicker .container__months .month-item.no-next-month .button-next-month{visibility:hidden}.litepicker .container__days{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:center;-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__days>div,.litepicker .container__days>a{padding:5px 0;width:var(--litepicker-day-width)}.litepicker .container__days .day-item{color:var(--litepicker-day-color);text-align:center;text-decoration:none;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__days .day-item:hover{color:var(--litepicker-day-color-hover);-webkit-box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover);box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover)}.litepicker .container__days .day-item.is-today{color:var(--litepicker-is-today-color)}.litepicker .container__days .day-item.is-locked{color:var(--litepicker-is-locked-color)}.litepicker .container__days .day-item.is-locked:hover{color:var(--litepicker-is-locked-color);-webkit-box-shadow:none;box-shadow:none;cursor:default}.litepicker .container__days .day-item.is-in-range{background-color:var(--litepicker-is-in-range-color);border-radius:0}.litepicker .container__days .day-item.is-start-date{color:var(--litepicker-is-start-color);background-color:var(--litepicker-is-start-color-bg);border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-flipped{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date{color:var(--litepicker-is-end-color);background-color:var(--litepicker-is-end-color-bg);border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date.is-flipped{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-end-date{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-highlighted{color:var(--litepicker-highlighted-day-color);background-color:var(--litepicker-highlighted-day-color-bg)}.litepicker .container__days .week-number{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:var(--litepicker-month-week-number-color);font-size:85%}.litepicker .container__footer{text-align:right;padding:10px 5px;margin:0 5px;background-color:var(--litepicker-footer-color-bg);-webkit-box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);border-bottom-left-radius:5px;border-bottom-right-radius:5px}.litepicker .container__footer .preview-date-range{margin-right:10px;font-size:90%}.litepicker .container__footer .button-cancel{background-color:var(--litepicker-button-cancel-color-bg);color:var(--litepicker-button-cancel-color);border:0;padding:3px 7px 4px;border-radius:3px}.litepicker .container__footer .button-cancel *{pointer-events:none}.litepicker .container__footer .button-apply{background-color:var(--litepicker-button-apply-color-bg);color:var(--litepicker-button-apply-color);border:0;padding:3px 7px 4px;border-radius:3px;margin-left:10px;margin-right:10px}.litepicker .container__footer .button-apply:disabled{opacity:0.7}.litepicker .container__footer .button-apply *{pointer-events:none}.litepicker .container__tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:4px;background-color:var(--litepicker-tooltip-color-bg);-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.25);box-shadow:0 1px 3px rgba(0,0,0,0.25);white-space:nowrap;font-size:11px;pointer-events:none;visibility:hidden}.litepicker .container__tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,0.12);border-right:5px solid transparent;border-left:5px solid transparent;content:\"\"}.litepicker .container__tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--litepicker-tooltip-color-bg);border-right:4px solid transparent;border-left:4px solid transparent;content:\"\"}\n", ""]), e.locals = {
      showWeekNumbers: "show-week-numbers",
      litepicker: "litepicker",
      containerMain: "container__main",
      containerMonths: "container__months",
      columns2: "columns-2",
      columns3: "columns-3",
      columns4: "columns-4",
      splitView: "split-view",
      monthItemHeader: "month-item-header",
      buttonPreviousMonth: "button-previous-month",
      buttonNextMonth: "button-next-month",
      monthItem: "month-item",
      monthItemName: "month-item-name",
      monthItemYear: "month-item-year",
      resetButton: "reset-button",
      monthItemWeekdaysRow: "month-item-weekdays-row",
      noPreviousMonth: "no-previous-month",
      noNextMonth: "no-next-month",
      containerDays: "container__days",
      dayItem: "day-item",
      isToday: "is-today",
      isLocked: "is-locked",
      isInRange: "is-in-range",
      isStartDate: "is-start-date",
      isFlipped: "is-flipped",
      isEndDate: "is-end-date",
      isHighlighted: "is-highlighted",
      weekNumber: "week-number",
      containerFooter: "container__footer",
      previewDateRange: "preview-date-range",
      buttonCancel: "button-cancel",
      buttonApply: "button-apply",
      containerTooltip: "container__tooltip"
    }, t.exports = e;
  }, function (t, e, i) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var i = function (t, e) {
            var i = t[1] || "",
                n = t[3];
            if (!n) return i;

            if (e && "function" == typeof btoa) {
              var o = (r = n, a = btoa(unescape(encodeURIComponent(JSON.stringify(r)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(l, " */")),
                  s = n.sources.map(function (t) {
                return "/*# sourceURL=".concat(n.sourceRoot || "").concat(t, " */");
              });
              return [i].concat(s).concat([o]).join("\n");
            }

            var r, a, l;
            return [i].join("\n");
          }(e, t);

          return e[2] ? "@media ".concat(e[2], " {").concat(i, "}") : i;
        }).join("");
      }, e.i = function (t, i, n) {
        "string" == typeof t && (t = [[null, t, ""]]);
        var o = {};
        if (n) for (var s = 0; s < (this || _global).length; s++) {
          var r = (this || _global)[s][0];
          null != r && (o[r] = !0);
        }

        for (var a = 0; a < t.length; a++) {
          var l = [].concat(t[a]);
          n && o[l[0]] || (i && (l[2] ? l[2] = "".concat(i, " and ").concat(l[2]) : l[2] = i), e.push(l));
        }
      }, e;
    };
  }, function (t, e, i) {
    "use strict";

    var n,
        o = {},
        s = function () {
      return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
    },
        r = function () {
      var t = {};
      return function (e) {
        if (void 0 === t[e]) {
          var i = document.querySelector(e);
          if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
            i = i.contentDocument.head;
          } catch (t) {
            i = null;
          }
          t[e] = i;
        }

        return t[e];
      };
    }();

    function a(t, e) {
      for (var i = [], n = {}, o = 0; o < t.length; o++) {
        var s = t[o],
            r = e.base ? s[0] + e.base : s[0],
            a = {
          css: s[1],
          media: s[2],
          sourceMap: s[3]
        };
        n[r] ? n[r].parts.push(a) : i.push(n[r] = {
          id: r,
          parts: [a]
        });
      }

      return i;
    }

    function l(t, e) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i],
            s = o[n.id],
            r = 0;

        if (s) {
          for (s.refs++; r < s.parts.length; r++) s.parts[r](n.parts[r]);

          for (; r < n.parts.length; r++) s.parts.push(g(n.parts[r], e));
        } else {
          for (var a = []; r < n.parts.length; r++) a.push(g(n.parts[r], e));

          o[n.id] = {
            id: n.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function c(t) {
      var e = document.createElement("style");

      if (void 0 === t.attributes.nonce) {
        var n = i.nc;
        n && (t.attributes.nonce = n);
      }

      if (Object.keys(t.attributes).forEach(function (i) {
        e.setAttribute(i, t.attributes[i]);
      }), "function" == typeof t.insert) t.insert(e);else {
        var o = r(t.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(e);
      }
      return e;
    }

    var h,
        p = (h = [], function (t, e) {
      return h[t] = e, h.filter(Boolean).join("\n");
    });

    function d(t, e, i, n) {
      var o = i ? "" : n.css;
      if (t.styleSheet) t.styleSheet.cssText = p(e, o);else {
        var s = document.createTextNode(o),
            r = t.childNodes;
        r[e] && t.removeChild(r[e]), r.length ? t.insertBefore(s, r[e]) : t.appendChild(s);
      }
    }

    function u(t, e, i) {
      var n = i.css,
          o = i.media,
          s = i.sourceMap;
      if (o && t.setAttribute("media", o), s && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(s)))), " */")), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) t.removeChild(t.firstChild);

        t.appendChild(document.createTextNode(n));
      }
    }

    var m = null,
        f = 0;

    function g(t, e) {
      var i, n, o;

      if (e.singleton) {
        var s = f++;
        i = m || (m = c(e)), n = d.bind(null, i, s, !1), o = d.bind(null, i, s, !0);
      } else i = c(e), n = u.bind(null, i, e), o = function () {
        !function (t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(i);
      };

      return n(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          n(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      (e = e || {}).attributes = "object" == typeof e.attributes ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = s());
      var i = a(t, e);
      return l(i, e), function (t) {
        for (var n = [], s = 0; s < i.length; s++) {
          var r = i[s],
              c = o[r.id];
          c && (c.refs--, n.push(c));
        }

        t && l(a(t, e), e);

        for (var h = 0; h < n.length; h++) {
          var p = n[h];

          if (0 === p.refs) {
            for (var d = 0; d < p.parts.length; d++) p.parts[d]();

            delete o[p.id];
          }
        }
      };
    };
  }, function (t, e, i) {
    "use strict";

    var n = (this || _global) && (this || _global).__assign || function () {
      return (n = Object.assign || function (t) {
        for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);

        return t;
      }).apply(this || _global, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = i(0),
        s = i(1),
        r = i(2);
    s.Litepicker.prototype.show = function (t) {
      void 0 === t && (t = null), this.emit("before:show", t);
      var e = t || (this || _global).options.element;

      if ((this || _global).triggerElement = e, !this.isShowning()) {
        if ((this || _global).options.inlineMode) return (this || _global).ui.style.position = "relative", (this || _global).ui.style.display = "inline-block", (this || _global).ui.style.top = null, (this || _global).ui.style.left = null, (this || _global).ui.style.bottom = null, void ((this || _global).ui.style.right = null);
        this.scrollToDate(t), this.render(), (this || _global).ui.style.position = "absolute", (this || _global).ui.style.display = "block", (this || _global).ui.style.zIndex = (this || _global).options.zIndex;
        var i = this.findPosition(e);
        (this || _global).ui.style.top = i.top + "px", (this || _global).ui.style.left = i.left + "px", (this || _global).ui.style.right = null, (this || _global).ui.style.bottom = null, this.emit("show", t);
      }
    }, s.Litepicker.prototype.hide = function () {
      this.isShowning() && ((this || _global).datePicked.length = 0, this.updateInput(), (this || _global).options.inlineMode ? this.render() : ((this || _global).ui.style.display = "none", this.emit("hide")));
    }, s.Litepicker.prototype.getDate = function () {
      return this.getStartDate();
    }, s.Litepicker.prototype.getStartDate = function () {
      return (this || _global).options.startDate ? (this || _global).options.startDate.clone() : null;
    }, s.Litepicker.prototype.getEndDate = function () {
      return (this || _global).options.endDate ? (this || _global).options.endDate.clone() : null;
    }, s.Litepicker.prototype.setDate = function (t, e) {
      void 0 === e && (e = !1);
      var i = new o.DateTime(t, (this || _global).options.format, (this || _global).options.lang);
      r.dateIsLocked(i, (this || _global).options, [i]) && !e ? this.emit("error:date", i) : (this.setStartDate(t), (this || _global).options.inlineMode && this.render(), this.emit("selected", this.getDate()));
    }, s.Litepicker.prototype.setStartDate = function (t) {
      t && ((this || _global).options.startDate = new o.DateTime(t, (this || _global).options.format, (this || _global).options.lang), this.updateInput());
    }, s.Litepicker.prototype.setEndDate = function (t) {
      t && ((this || _global).options.endDate = new o.DateTime(t, (this || _global).options.format, (this || _global).options.lang), (this || _global).options.startDate.getTime() > (this || _global).options.endDate.getTime() && ((this || _global).options.endDate = (this || _global).options.startDate.clone(), (this || _global).options.startDate = new o.DateTime(t, (this || _global).options.format, (this || _global).options.lang)), this.updateInput());
    }, s.Litepicker.prototype.setDateRange = function (t, e, i) {
      void 0 === i && (i = !1), (this || _global).triggerElement = void 0;
      var n = new o.DateTime(t, (this || _global).options.format, (this || _global).options.lang),
          s = new o.DateTime(e, (this || _global).options.format, (this || _global).options.lang);
      ((this || _global).options.disallowLockDaysInRange ? r.rangeIsLocked([n, s], (this || _global).options) : r.dateIsLocked(n, (this || _global).options, [n, s]) || r.dateIsLocked(s, (this || _global).options, [n, s])) && !i ? this.emit("error:range", [n, s]) : (this.setStartDate(n), this.setEndDate(s), (this || _global).options.inlineMode && this.render(), this.updateInput(), this.emit("selected", this.getStartDate(), this.getEndDate()));
    }, s.Litepicker.prototype.gotoDate = function (t, e) {
      void 0 === e && (e = 0);
      var i = new o.DateTime(t);
      i.setDate(1), (this || _global).calendars[e] = i.clone(), this.render();
    }, s.Litepicker.prototype.setLockDays = function (t) {
      (this || _global).options.lockDays = o.DateTime.convertArray(t, (this || _global).options.lockDaysFormat), this.render();
    }, s.Litepicker.prototype.setHighlightedDays = function (t) {
      (this || _global).options.highlightedDays = o.DateTime.convertArray(t, (this || _global).options.highlightedDaysFormat), this.render();
    }, s.Litepicker.prototype.setOptions = function (t) {
      delete t.element, delete t.elementEnd, delete t.parentEl, t.startDate && (t.startDate = new o.DateTime(t.startDate, (this || _global).options.format, (this || _global).options.lang)), t.endDate && (t.endDate = new o.DateTime(t.endDate, (this || _global).options.format, (this || _global).options.lang));
      var e = n(n({}, (this || _global).options.dropdowns), t.dropdowns),
          i = n(n({}, (this || _global).options.buttonText), t.buttonText),
          s = n(n({}, (this || _global).options.tooltipText), t.tooltipText);
      (this || _global).options = n(n({}, (this || _global).options), t), (this || _global).options.dropdowns = n({}, e), (this || _global).options.buttonText = n({}, i), (this || _global).options.tooltipText = n({}, s), !(this || _global).options.singleMode || (this || _global).options.startDate instanceof o.DateTime || ((this || _global).options.startDate = null, (this || _global).options.endDate = null), (this || _global).options.singleMode || (this || _global).options.startDate instanceof o.DateTime && (this || _global).options.endDate instanceof o.DateTime || ((this || _global).options.startDate = null, (this || _global).options.endDate = null);

      for (var r = 0; r < (this || _global).options.numberOfMonths; r += 1) {
        var a = (this || _global).options.startDate ? (this || _global).options.startDate.clone() : new o.DateTime();
        a.setDate(1), a.setMonth(a.getMonth() + r), (this || _global).calendars[r] = a;
      }

      (this || _global).options.lockDays.length && ((this || _global).options.lockDays = o.DateTime.convertArray((this || _global).options.lockDays, (this || _global).options.lockDaysFormat)), (this || _global).options.highlightedDays.length && ((this || _global).options.highlightedDays = o.DateTime.convertArray((this || _global).options.highlightedDays, (this || _global).options.highlightedDaysFormat)), this.render(), (this || _global).options.inlineMode && this.show(), this.updateInput();
    }, s.Litepicker.prototype.clearSelection = function () {
      (this || _global).options.startDate = null, (this || _global).options.endDate = null, (this || _global).datePicked.length = 0, this.updateInput(), this.isShowning() && this.render(), this.emit("clear:selection");
    }, s.Litepicker.prototype.destroy = function () {
      (this || _global).ui && (this || _global).ui.parentNode && ((this || _global).ui.parentNode.removeChild((this || _global).ui), (this || _global).ui = null), this.emit("destroy");
    };
  }]);
});
export default exports;
export const Litepicker = exports.Litepicker;